export const handleFilterBySource = (
  _,
  val,
  reason,
  samplesData,
  setChosenLabel,
  setPredictionsToView,
  filterSource
) => {
  const filteredPredictionsArr = [];
  // eslint-disable-next-line array-callback-return
  samplesData.map((dataObj) => {
    if (dataObj[filterSource] === val) {
      filteredPredictionsArr.push(dataObj);
    }
  });
  setChosenLabel(true);
  setPredictionsToView(filteredPredictionsArr);
  if (reason === 'clear') {
    setChosenLabel(false);
  }
};

export const handleViewPredictionsData = (
  predictionsToView,
  onViewSamples,
  filterType
) => {
  if (predictionsToView.length === 0) {
    return onViewSamples();
  }
  return onViewSamples(filterType, predictionsToView);
};

export const filterSamplesByFilterSource = (
  samplesData,
  setUniqueLabelsList,
  filterSource
) => {
  if (samplesData && samplesData.length > 0) {
    const filterLabels = new Set(
      samplesData
        .map((item) => item[filterSource])
        .filter((a) => a !== undefined && a !== null)
    );
    setUniqueLabelsList([...filterLabels]);
  }
};
